module.exports = __webpack_public_path__ + "img/sg_room1.73947888.jpg";